import React from 'react'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

class Column extends React.Component {

    renderItems(list, templateProp) {
        let items = list || [];
        let template = templateProp || ((item, i) => {
            return (
                <div key={i}>
                    {JSON.stringify(item)}
                </div>
            )
        });

        return items.map(template);
    }
    render () {
        return (
            <div {...this.props} className={['component-column', this.props.className].join(' ')}>
                <ReactCSSTransitionGroup transitionName="basic" transitionEnterTimeout={300} transitionLeaveTimeout={200} >
                    { this.renderItems(this.props.list, this.props.template) }
                </ReactCSSTransitionGroup>
            </div>
        )
    }
}

export default Column;



// WEBPACK FOOTER //
// ./web-app/components/column.jsx